__turbopack_context__.v({
  "actions": "WhatsNext-module-scss-module__Bx55Cq__actions",
  "container": "WhatsNext-module-scss-module__Bx55Cq__container",
  "header": "WhatsNext-module-scss-module__Bx55Cq__header",
  "icon": "WhatsNext-module-scss-module__Bx55Cq__icon",
  "next": "WhatsNext-module-scss-module__Bx55Cq__next",
  "step": "WhatsNext-module-scss-module__Bx55Cq__step",
  "stepNumber": "WhatsNext-module-scss-module__Bx55Cq__stepNumber",
  "steps": "WhatsNext-module-scss-module__Bx55Cq__steps",
  "summary": "WhatsNext-module-scss-module__Bx55Cq__summary",
  "summaryLabel": "WhatsNext-module-scss-module__Bx55Cq__summaryLabel",
  "summaryRow": "WhatsNext-module-scss-module__Bx55Cq__summaryRow",
  "summaryValue": "WhatsNext-module-scss-module__Bx55Cq__summaryValue",
});
